export default "__VITE_ASSET__BdC3YLur__"